<template>
  <div class="detection_error_box">
    <!-- 检测失败开始 -->
    <div>
      <div class="detection_error">
        <img
          :src="
            sInfo == 2
              ? require('@/assets/image/detection_error.png')
              : require('@/assets/image/detection_center.png')
          "
          alt=""
        />
        <div
          class="hint"
          :style="{
            color: sInfo == 2 ? '#ea1313' : '#000',
            margin: '30px 0 0',
          }"
        >
          {{
            sInfo == 0
              ? "设备连接中···"
              : sInfo == 2
              ? "设备检测失败，请刷新重新检测"
              : (isSign ? "设备检测中，已检测到":"设备检测完毕，检测到") + controlRot.length + "个答题器"
          }}
        </div>
        <div v-if="sInfo == 1 && !jianceSelectFlag" style="margin-bottom: 30px">
          答题器启动后，按下【OK】按键
        </div>
        <br />
        <a-button
          type="primary"
          size="large"
          v-if="sInfo == 2"
          :loading="refashVoteLoading"
          @click="refashVote"
          >刷新</a-button
        >
      </div>
    </div>
    <div>
      <!-- 检测中或结束 -->
      <div class="serial_number_box">
        <a-row :gutter="[20, 20]">
          <a-col
            :md="12"
            :lg="6"
            :xl="4"
            :xxl="4"
            v-for="(v, i) in controlRot"
            :key="i"
            class="controlRotCol"
          >
            <div class="controlRot" :class="{ ontrolRotActive: !!v.name }">
              <div class="title">
                答题器编号：<span>{{ v.iKeyID }}</span>
              </div>
              <div class="name" v-if="v.name">姓名: {{ v.name }}</div>
            </div>
          </a-col>
        </a-row>
      </div>
      <div v-if="sInfo == 1">
        <div class="go_authentication" v-if="!jianceSelectFlag">
          <a-button type="primary" size="large" @click="signOut"
            >去录入</a-button
          >
          <div class="hint">
            如答题器已检测完毕，请体验人员陆续进行身份证或人脸识别，系统将自动进行答题器分配
          </div>
        </div>
        <div class="go_authentication" v-else>
          <a-button type="primary" size="large" @click="signNext"
            >录入已完成，进行下一步</a-button
          >
          <div class="hint">
            请体验人员陆续进行
            <span style="font-weight: bold">{{
              jianceSelectType == 1 ? "身份证识别" : "人脸识别"
            }}</span>
            ，系统将自动进行答题器分配
          </div>
        </div>
      </div>
    </div>
    <div class="jianceSelect" v-if="jianceSelect">
      <div class="jianceContent">
        <div class="jianceSelectItem">
          <div class="jianceTitle">身份证录入</div>
          <img src="@/assets/image/img_sfzlr.png" />
          <a-button
            type="primary"
            size="large"
            style="padding-left: 40px; padding-right: 40px"
            v-if="jianceSelectType == 1"
            >请进行身份证刷卡录入</a-button
          >
          <a-button
            type="primary"
            size="large"
            style="padding-left: 40px; padding-right: 40px"
            v-else
            @click="readIdcard(1)"
            >确认录入</a-button
          >
          <div style="margin-top: 10px" v-if="jianceSelectType == 1">
            当前窗口关闭后也
            <span style="color: #000; font-weight: bold">不会影响</span>
            身份证录入
          </div>
        </div>
        <!-- <div class="jianceSelectItem">
          <div class="jianceTitle">人脸录入</div>
          <img src="@/assets/image/img_rlsb1.png" />
          <a-button type="primary" size="large" style="width: 144px"
            >确认录入</a-button
          >
        </div> -->
        <div class="jianceClose" @click="jianceSelect = false">
          <a-icon type="close" size="20" style="color: #a1a8b0" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //是否正在连接
    refashVoteLoading: {
      type: Boolean,
      default: false,
    },
    //是否正在签到中
    isSign:{
      type: Boolean,
      default: false,
    },
    //连接状态 //0未连接或正在连接0失败1成功
    sInfo: {
      type: [String, Number],
      default: 0,
    },
    //已经读取或签到得遥控器数据
    controlRot: {
      type: Array,
      default() {
        return {};
      },
    },
    //是否已经选择录入人员的方式
    jianceSelectFlag: {
      type: Boolean,
      default: false,
    },
    //已选择的录入人员的方式1身份证2人脸
    jianceSelectType: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      jianceSelect: false,
    };
  },
  methods: {
    //刷新答题设备
    refashVote() {
      this.$emit("refashVote");
    },
    //选择录入类型
    readPerson() {
      this.jianceSelect = true;
    },
    //退出签到执行录入人员信息绑定
    signOut() {
      this.$emit("signOut");
    },
    //选择身份证录入
    readIdcard(type) {
      this.$emit("readIdcard", type);
    },
    //录入完成
    signNext() {
      this.$emit("signNext");
    },
  },
};
</script>

<style lang="scss" scoped>
.detection_error_box {
  width: 100%;
  padding-top: 78px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100vh - 100px - 150px);

  .detection_error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 300px;
      height: 300px;
    }

    .hint {
      margin: 30px 0;
      font-size: 18px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #ea1313;
    }
  }
}

.serial_number_box {
  .ant-btn-primary {
    width: 140px;
    height: 60px;
    margin-right: 30px;
    background: #fafbff;
    border: 1px solid #0073ff;
    color: #0073ff;
    margin-top: 10px;
  }
}
.go_authentication {
  text-align: right;
  .hint {
    margin-top: 10px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #ea1313;
  }
}

.jianceSelect {
  position: fixed;
  background: rgba($color: #000000, $alpha: 0.5);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .jianceContent {
    display: flex;
    align-items: start;
    .jianceSelectItem {
      box-sizing: border-box;
      width: 360px;
      min-height: 360px;
      background: #fff;
      border-radius: 10px;
      margin: 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 20px 0;
      box-sizing: border-box;
      .jianceTitle {
        font-size: 18px;
        font-weight: 400;
        color: #011733;
      }
      img {
        width: 200px;
        height: 200px;
        margin-top: 34px;
        margin-bottom: 20px;
      }
    }
    .jianceClose {
      width: 30px;
      height: 30px;
      background: #f5f6fa;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}

.controlRotCol {
  animation: fadeIn ease 1s;
  -webkit-animation: fadeIn ease 1s;
  -moz-animation: fadeIn ease 1s;
  -o-animation: fadeIn ease 1s;
  -ms-animation: fadeIn ease 1s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.controlRot {
  border: 1px solid #0073ff;
  border-radius: 4px;
  padding-left: 20px;
  box-sizing: border-box;
  background: #fafbff;
  white-space: nowrap;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: all 0.5s;
  .title {
    span {
      font-size: 26px;
      font-weight: bold;
      color: #0073ff;
    }
  }
  .name {
    font-size: 14px;
    height: 30px;
  }
}

.ontrolRotActive {
  background: #0073ff;
  color: #fff;
  .title {
    span {
      color: #fff;
    }
  }
}
</style>